export const buildCache = async (
  fetchAllRows: () => Promise<any[] | undefined>,
  dataKey: string
): Promise<unknown[]> => {
  const rows = await fetchAllRows();
  if (!rows) {
    throw new Error('$getAllIds: failed to fetch dataset records');
  }
  return rows.map((row: Record<string, unknown>) => row[dataKey]);
};
